import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }

      const valid = regex.test(control.value);

      return valid ? null : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get("new_password").value;
    const confirmPassword: string = control.get("repeat_password").value;
    const oldPassword: string = control.get("old_password")
      ? control.get("old_password").value
      : null;

    if (oldPassword && oldPassword === password) {
      control
        .get("new_password")
        .setErrors({ NewPasswordMustBeDifferent: true });
    }

    if (password !== confirmPassword) {
      control.get("repeat_password").setErrors({ NoPassswordMatch: true });
    }
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/custom-validators.ts